import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import DialogPopup from "../../../../components/DialogPopup";
import { logout } from "../../../auth/slices/auth.slice";
import { setSessionData } from "../../../auth/slices/userSession.slice";
import { closeDialog } from "../../slices/dialog.slice";
import { isSSOEnabled } from "../../../../utils/helpers";

function IdleTimerComp() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [showPrompt, setShowPrompt] = useState(false);
  const tenantData = useSelector((state) => state.auth?.tenantData);

  const handleOnIdle = () => {
    setShowPrompt(false);
    dispatch(closeDialog());
    dispatch(
      setSessionData({
        tenantId: tenantData?._id,
        postLoginRoute: window?.location?.pathname,
      })
    );
    dispatch(logout());
  };

  const handlePrompt = () => {
    setShowPrompt(true);
  };

  const isSSORegisterPage = isSSOEnabled && pathname === "/register";
  const timeoutInSeconds = isSSORegisterPage ? 900 : 1800;

  const { reset } = useIdleTimer({
    timeout: 1000 * timeoutInSeconds,
    onIdle: handleOnIdle,
    debounce: 500,
    promptBeforeIdle: 1000 * 30,
    onPrompt: handlePrompt,
  });

  const buttonArray = [
    {
      id: 1,
      name: "EXTEND SESSION",
      variant: "contained",
      onClickHandler: () => {
        reset();
        setShowPrompt(false);
      },
      show: true,
    },
    {
      id: 2,
      name: "LOGOUT",
      variant: "contained",
      onClickHandler: () => dispatch(logout()),
      show: true,
    },
  ];

  const warningMsg = (
    <Typography variant="subtitle1">
      Your session will soon expire due to inactivity. You will be automatically
      logged out in 30 seconds. Please click extend session to continue your
      session.
    </Typography>
  );

  return (
    <DialogPopup
      title="Session Inactivity Warning"
      content={warningMsg}
      openPopup={showPrompt}
      buttonArray={buttonArray}
      showActionBtn
    />
  );
}

export default IdleTimerComp;
